var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 404,
    viewBox: "0 0 525 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.64 398.727C381.325 397.809 381.325 393.553 384.64 392.639C387.438 391.864 388.027 388.506 385.626 386.987C382.785 385.187 384.234 381.14 387.7 381.195C390.628 381.244 392.328 378.214 390.567 376.096C388.479 373.587 391.238 370.145 394.513 371.17C397.28 372.035 399.931 369.631 398.977 367.122C397.846 364.151 401.642 361.649 404.409 363.543C406.744 365.144 410.085 363.598 410.031 360.943C409.966 357.8 414.429 356.485 416.417 359.062C418.092 361.239 421.799 360.706 422.649 358.168C423.661 355.161 428.354 355.161 429.362 358.168C430.216 360.706 433.918 361.239 435.594 359.062C436.469 357.927 437.829 357.549 439.067 357.751V126.742H386.423L347.474 100.441V403.36H386.663C387.722 401.691 386.907 399.358 384.633 398.73L384.64 398.727Z",
    fill: "#A3C5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4031 403.36C15.4651 401.691 14.6507 399.355 12.376 398.727C9.06086 397.809 9.06086 393.553 12.376 392.639C15.1745 391.864 15.7629 388.506 13.3626 386.987C10.5211 385.187 11.9706 381.136 15.4364 381.195C18.3641 381.244 20.0647 378.214 18.3031 376.096C16.215 373.587 18.974 370.145 22.2497 371.17C25.0159 372.035 27.6673 369.631 26.7129 367.122C25.5827 364.151 29.3786 361.649 32.1448 363.543C34.4805 365.144 37.8208 363.598 37.7669 360.943C37.7024 357.8 42.1656 356.485 44.1532 359.062C45.8288 361.239 49.535 360.706 50.3853 358.168C50.8912 356.664 52.3155 355.913 53.7435 355.913V403.36L14.4031 403.363V403.36Z",
    fill: "#F39200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7432 100.441L14.7939 126.739H53.7432V100.441Z",
    fill: "#A3C5EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.61 1.27124L386.427 126.739H478.02L292.204 1.27124H200.61Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 273.76V234.119H135.62V273.448L187.5 273.76Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 234.119H83.7412V273.138L135.621 273.448V234.119Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.62 273.448V312.158H187.5V273.76L135.62 273.448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 312.158V273.448L83.7412 273.138V312.158H135.621Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M394.56 273.047H364.494V312.071H394.56V273.047Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M394.56 234.027H364.494V273.047H394.56V234.027Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M424.622 273.047H394.56V312.071H424.622V273.047Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M424.625 234.027H394.56V273.047H424.625V234.027Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.555 158.028H83.7412V204.782H141.555V158.028Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.369 158.028H141.555V204.779H199.369V158.028Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.993 158.028H257.179V204.779H314.993V158.028Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M257.18 158.028H199.369V204.779H257.18V158.028Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M314.993 234.027H226.08V403.357H314.993V234.027Z",
    fill: "#A3C5EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M386.667 403.36C387.729 401.691 386.914 399.354 384.64 398.727C381.325 397.809 381.325 393.553 384.64 392.639C387.438 391.864 388.027 388.506 385.626 386.987C382.785 385.187 384.234 381.136 387.7 381.195C390.628 381.244 392.328 378.214 390.567 376.096C388.479 373.587 391.238 370.145 394.513 371.17C397.28 372.035 399.931 369.631 398.977 367.122C397.846 364.151 401.642 361.649 404.408 363.543C406.744 365.144 410.084 363.598 410.031 360.943C409.966 357.8 414.429 356.485 416.417 359.062C418.092 361.239 421.799 360.705 422.649 358.168C423.661 355.161 428.354 355.161 429.362 358.168C430.216 360.705 433.918 361.239 435.594 359.062C437.578 356.485 442.041 357.8 441.98 360.943C441.926 363.598 445.266 365.14 447.602 363.543C450.368 361.649 454.164 364.151 453.034 367.122C452.08 369.631 454.731 372.035 457.497 371.17C460.773 370.145 463.532 373.587 461.444 376.096C459.679 378.214 461.383 381.244 464.311 381.195C467.776 381.136 469.226 385.184 466.384 386.987C463.984 388.506 464.572 391.867 467.371 392.639C470.686 393.556 470.686 397.812 467.371 398.727C465.096 399.354 464.282 401.687 465.34 403.357H386.66L386.667 403.36Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1434 402.159V403.357H72.7656L73.067 402.159H92.1434Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5502 247.166L56.8429 250.417L54.7764 247.017L59.3831 244.658L61.5502 247.166Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.397 333.549L136.768 325.704C136.044 326.742 135.918 328.008 135.904 328.698C135.897 329.134 135.897 333.803 135.904 337.174L131.401 333.549H131.397Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.889 328.554C159.892 327.416 159.613 326.26 158.49 325.076C157.367 323.892 155.688 323.609 155.688 323.609L162.863 322.066L165.715 329.335L159.878 331.392C159.878 331.392 159.885 329.693 159.889 328.554Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.787 350.583C161.887 351.615 160.998 352.129 159.114 352.692L158.615 350.791C158.615 350.791 160.768 350.472 161.787 350.583Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M161.965 397.302L161.355 395.359L168.879 393.865C169.084 394.725 169.252 395.431 169.378 395.955L161.965 397.299V397.302Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.335 293.146C55.335 293.146 57.5056 295.902 60.7238 299.989C61.6782 301.199 63.2174 301.919 64.857 301.919H92.8922C95.6978 301.919 97.9689 299.856 97.9689 297.314V286.648C97.9689 284.104 100.244 282.044 103.046 282.044H130.539C133.345 282.044 135.616 279.981 135.616 277.44V234.034",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M478.018 403.357H0",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6416 292.59L53.6416 403.59",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6416 238.59L53.6416 292.59",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7412 100.441V238.706",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M347.476 403.357V226.882C347.476 224.337 345.201 222.278 342.399 222.278H336.314C333.509 222.278 331.237 224.341 331.237 226.882V261.337C331.237 263.881 328.963 265.941 326.161 265.941H320.076C317.27 265.941 314.999 268.004 314.999 270.545V403.353",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M347.476 100.441V197.669",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M384.232 63.4129L478.018 126.739H386.425L200.608 1.27124L14.792 126.739H53.7413",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M200.608 1.27124H292.202L346.126 37.6816C347.002 38.2738 348.067 38.5927 349.158 38.5927H524.641",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M439.068 126.739V357.748",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.078 304.265V234.027H314.991V241.134",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M304.027 323.446H287.526",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M175.408 312.071H187.499V234.027H83.7393V312.071H141.266",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 312.071H169.531",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M314.992 158.028H83.7393V204.782H314.992V158.028Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.499 273.047H83.7393",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.619 306.933V312.071",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M424.624 234.027H364.492V312.067H424.624V234.027Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M424.62 273.047H364.492",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M394.559 234.027V312.071",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.553 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M199.367 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M141.553 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M257.178 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M199.367 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M257.178 158.028V204.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M386.665 403.36C387.727 401.691 386.912 399.354 384.638 398.727C381.323 397.809 381.323 393.553 384.638 392.639C387.436 391.864 388.025 388.506 385.624 386.987C382.783 385.187 384.232 381.136 387.698 381.195C390.626 381.244 392.326 378.214 390.565 376.096C388.477 373.587 391.236 370.145 394.511 371.17C397.278 372.035 399.929 369.631 398.975 367.122C397.844 364.151 401.64 361.649 404.407 363.543C406.742 365.144 410.082 363.598 410.029 360.943C409.964 357.8 414.427 356.485 416.415 359.062C418.09 361.239 421.797 360.705 422.647 358.168C423.659 355.161 428.352 355.161 429.36 358.168C430.214 360.705 433.916 361.239 435.592 359.062C437.576 356.485 442.039 357.8 441.978 360.943C441.924 363.598 445.265 365.14 447.6 363.543C450.366 361.649 454.162 364.151 453.032 367.122C452.078 369.631 454.729 372.035 457.495 371.17C460.771 370.145 463.53 373.587 461.442 376.096C459.677 378.214 461.381 381.244 464.309 381.195C467.774 381.136 469.224 385.184 466.382 386.987C463.982 388.506 464.571 391.867 467.369 392.639C470.684 393.556 470.684 397.812 467.369 398.727C465.094 399.354 464.28 401.687 465.338 403.357",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4012 403.36C15.4632 401.691 14.6487 399.355 12.374 398.727C9.05891 397.809 9.05891 393.553 12.374 392.639C15.1725 391.864 15.7609 388.506 13.3607 386.987C10.5191 385.187 11.9686 381.136 15.4344 381.195C18.3621 381.244 20.0627 378.214 18.3011 376.096C16.213 373.587 18.972 370.145 22.2477 371.17C25.0139 372.035 27.6653 369.631 26.7109 367.122C25.5808 364.151 29.3767 361.649 32.1429 363.543C34.4785 365.144 37.8188 363.598 37.765 360.943C37.7004 357.8 42.1636 356.485 44.1513 359.062C45.7299 361.112 49.1096 360.758 50.2111 358.587",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.9a3a3b2e.svg";
export { ForwardRef as ReactComponent };